export async function getGuide(dealerId: string) {
  const url = `/internal-api/dealer/guide?id=${dealerId}`;
  if (dealerId) {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      let dataFormat = data;
      return dataFormat;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
